import { render, staticRenderFns } from "./save_filter.vue?vue&type=template&id=2ff961c1&"
import script from "./save_filter.vue?vue&type=script&lang=js&"
export * from "./save_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports